export default [
  {
    // 캠핑장
    path: 'camp',
    redirect: { name: 'CampDailyPaymentList' },
    children: [
      {
        // 마감관리
        path: 'daily-report-mng',
        redirect: { name: 'CampClosingManage' },
        children: [
          {
            path: 'list',
            name: 'CampClosingManage',
            meta: { menu: 'camp', keepAlive: true },
            component: () => import('@/pages/reportMng/camp/dailyReportMng/ClosingManageListView.vue')
          }
        ]
      },
      {
        // 일일 납입내역
        path: 'daily-payment-history',
        redirect: { name: 'CampDailyPaymentList' },
        children: [
          {
            path: 'list',
            name: 'CampDailyPaymentList',
            meta: { menu: 'camp', keepAlive: true },
            component: () => import('@/pages/reportMng/camp/DailyPaymentListView.vue')
          }
        ]
      },
      {
        // 결의서
        path: 'resolutions',
        redirect: { name: 'CampDailyResolutionList' },
        children: [
          {
            path: 'list',
            name: 'CampDailyResolutionList',
            meta: { menu: 'camp', keepAlive: true },
            component: () => import('@/pages/reportMng/camp/DailyResolutionListView.vue')
          }
        ]
      },
      {
        // 결제/환불 신청 현황
        path: 'payment-refund-status',
        redirect: { name: 'CampRequestStatusList' },
        children: [
          {
            path: 'list',
            name: 'CampRequestStatusList',
            meta: { menu: 'camp', keepAlive: true },
            component: () => import('@/pages/reportMng/camp/RequestStatusListView.vue')
          }
        ]
      },
      {
        // 일일상품 결제/환불 일보
        path: 'daily-product-payment',
        redirect: { name: 'CampDailyIncomeAcmdtFcltList' },
        children: [
          {
            path: 'list',
            name: 'CampDailyIncomeAcmdtFcltList',
            meta: { menu: 'camp', keepAlive: true },
            component: () => import('@/pages/reportMng/camp/DailyIncomeAcmdtFcltListView.vue')
          }
        ]
      },
      {
        // 일일 영업일보
        path: 'daily-sales-report',
        redirect: { name: 'CampDailySalesList' },
        children: [
          {
            path: 'list',
            name: 'CampDailySalesList',
            meta: { menu: 'camp', keepAlive: true },
            component: () => import('@/pages/reportMng/camp/DailySalesListView.vue')
          }
        ]
      },
      {
        // 품목(시설)별 영업일보
        path: 'item-sales-report',
        redirect: { name: 'CampDailyReportByAcmdtFcltPrgRmList' },
        children: [
          {
            path: 'list',
            name: 'CampDailyReportByAcmdtFcltPrgRmList',
            meta: { menu: 'camp', keepAlive: true },
            component: () => import('@/pages/reportMng/camp/DailyReportByAcmdtFcltPrgRmListView.vue')
          }
        ]
      },
      {
        // 품목 구분별 영업일보
        path: 'item-type-sales-report',
        redirect: { name: 'CampDailyReportByAcmdtFcltList' },
        children: [
          {
            path: 'list',
            name: 'CampDailyReportByAcmdtFcltList',
            meta: { menu: 'camp', keepAlive: true },
            component: () => import('@/pages/reportMng/camp/DailyReportByAcmdtFcltListView.vue')
          }
        ]
      },
      {
        // 회원 영업일보
        path: 'member-sales-report',
        redirect: { name: 'CampMemberReportList' },
        children: [
          {
            path: 'list',
            name: 'CampMemberReportList',
            meta: { menu: 'camp', keepAlive: true },
            component: () => import('@/pages/reportMng/camp/MemberReportListView.vue')
          }
        ]
      },
      {
        // 환불 회원 현황
        path: 'refund-member-status',
        redirect: { name: 'CampMemberRequestStatusList' },
        children: [
          {
            path: 'list',
            name: 'CampMemberRequestStatusList',
            meta: { menu: 'camp', keepAlive: true },
            component: () => import('@/pages/reportMng/camp/MemberRequestStatusListView.vue')
          }
        ]
      },
      {
        // 카드 승인/취소 내역
        path: 'card-approval-history',
        redirect: { name: 'CampDssCardHistoryList' },
        children: [
          {
            path: 'list',
            name: 'CampDssCardHistoryList',
            meta: { menu: 'camp', keepAlive: true },
            component: () => import('@/pages/reportMng/camp/DssCardHistoryListView.vue')
          }
        ]
      },
      {
        // 매출 현황
        path: 'sales-status',
        redirect: { name: 'CampTotalSalesStatusList' },
        children: [
          {
            path: 'list',
            name: 'CampTotalSalesStatusList',
            meta: { menu: 'camp', keepAlive: true },
            component: () => import('@/pages/reportMng/camp/TotalSalesStatusListView.vue')
          }
        ]
      }
    ]
  }
]
